module.exports = __webpack_public_path__ + "images/gradients/gradient-peach.2e1f915336522cc47f95.svg";